import { Component, Input, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from '../../services/shared-signals.service';

@Component({
  selector: 'taly-custom-accordion',
  templateUrl: './custom-accordion.component.html',
  styleUrls: ['./custom-accordion.component.scss']
})
export class CustomAccordionComponent implements OnInit {

  transferSignal = inject(SharedSignalsService);
  @Input() items: any[] = [];
  @Input() textDirection: any;
  activeIndex: number[] = []; 

  constructor() {
    effect(() => { 
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {}

  toggleActive(index: number): void {
    if (this.activeIndex.includes(index)) {
      this.activeIndex = this.activeIndex.filter(i => i !== index);
    } else {
      this.activeIndex.push(index);
    }
  }

  isActive(index: number): boolean {
    return this.activeIndex.includes(index);
  }
}
